import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Select from './Select';

import {
  inputPropTypes,
  metaPropTypes,
  inputDefaultProps,
  metaDefaultProps,
} from '../../forms/input/InputPropTypes';
import { clearAreas, getAreas } from '../../../../actions/hcm/Organization';

const HcmAreaSelect = ({
  dispatchGetAreas,
  dispatchClearAreas,
  areas,
  isLoading,
  isMulti,
  input,
  meta,
  organizationId,
  ...rest
}) => {
  useLayoutEffect(() => {
    if (organizationId) {
      dispatchGetAreas({ organizationId });
    }

    return () => {
      dispatchClearAreas();
    };
  }, [organizationId]);

  return (
    <Select
      options={areas}
      isLoading={isLoading}
      isMulti={isMulti}
      input={input}
      meta={meta}
      {...rest}
    />
  );
};

HcmAreaSelect.propTypes = {
  dispatchGetAreas: PropTypes.func.isRequired,
  dispatchClearAreas: PropTypes.func.isRequired,
  organizationId: PropTypes.number,
  isMulti: PropTypes.bool,
  input: inputPropTypes,
  areas: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
  meta: metaPropTypes,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

HcmAreaSelect.defaultProps = {
  input: inputDefaultProps,
  meta: metaDefaultProps,
  organizationId: null,
  isLoading: false,
  isMulti: false,
  areas: [],
  isDisabled: false,
};

const mapStateToProps = ({ HcmUnit }) => ({
  areas: HcmUnit.Organization.getIn(['areas', 'content']).map((area) => ({
    value: area.get('id'),
    label: area.get('name'),
  })),
  isLoading: HcmUnit.Organization.getIn(['areas', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetAreas: getAreas,
  dispatchClearAreas: clearAreas,
};

export default connect(mapStateToProps, mapDispatchToProps)(HcmAreaSelect);
